import React, { useEffect, useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CART_URL } from '../data/content';
export function StickyBuyBar() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 700);
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <div className={`fixed inset-x-0 bottom-0 z-50 border-t border-beige bg-white/95 px-4 py-3 shadow-[0_-4px_20px_rgba(0,0,0,0.08)] backdrop-blur transition-transform duration-300 lg:hidden ${visible ? 'translate-y-0' : 'translate-y-full'}`} data-id="element-172" data-mp="3li8piu8d2r7j">
      <div className="mx-auto flex max-w-md items-center justify-between gap-3" data-id="element-173" data-mp="3qfs640sj7g2n">
        <div className="leading-tight" data-id="element-174" data-mp="211djpn4zk5ab">
          <span className="block text-[11px] font-bold uppercase tracking-wide text-[#9AA093] line-through" data-id="element-175" data-mp="212ezg4wy5fyd">
            $27.980
          </span>
          <span className="font-display text-xl font-black text-green-brand" data-id="element-176" data-mp="29fit9y3mfufa">$13.990</span>
        </div>
        <a href={CART_URL} className="flex flex-1 items-center justify-center gap-2 rounded-full bg-green-brand py-3 text-sm font-extrabold uppercase tracking-wide text-white shadow-md transition-colors hover:bg-green-deep" data-id="element-177" data-mp="2ed11fm9te5m8">
          Quiero mi guía
          <ArrowRightIcon className="h-4 w-4" data-id="element-178" data-mp="2s5h8qz9r0psy" />
        </a>
      </div>
    </div>;
}